import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserPermissionType } from '../api/organization/user-permissions';

@Injectable()
export class CompanyPermissionGuard {
  constructor(private authService: AuthService, private router: Router) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    const user = this.authService.currentUser;

    if (!user) {
      return this.router.createUrlTree(['login']);
    }

    // Get the required permission from route data
    const requiredPermission = route.data.permission as UserPermissionType;

    // Check if user has the specific permission (e.g., UserPermissionType.Users)
    // The condition evaluates to false if they have no permission matching 'Users'
    const hasPermission = user.permissions?.some(p => p.permission === requiredPermission);

    const hasAccess = this.authService.isCompanyAdmin()
      || this.authService.isCompany()
      || user.permissions?.some(p =>
        p.permission === UserPermissionType.Users
      );

    if (hasAccess) {
      return true;
    }

    // Role-based requirement: Company Admin and Company users are redirected to company-profile
    // effectively denying access to billing/users while remaining in the settings module.
    if (this.authService.isCompanyAdmin() || this.authService.isCompany()) {
      return this.router.createUrlTree(['/main/company/company-settings/company-profile']);
    }

    return this.router.createUrlTree(['/main/company/company-settings/company-profile']);
  }
}
